import { IconSelectedOutline, IconVol } from "@/components/icon/master"
import { DdpCta } from "@/components/shared/DdpCta"
import { Selector } from "@/components/shared/Selector"
import { useEffect, useState } from "react"
import { TCocktailDetailProps } from "../type"
import { TCocktail } from "@/shared/types"
import { useCmsStore } from "@/components/AppHooks"
import { useSearchParams } from "next/navigation"

export function CocktailIngredients(props: TCocktailDetailProps & { cocktailInfo: TCocktail, changeMlToOz: boolean, onChangeSelectedPersons: (value: number) => void }) {
    const [selected, setSelected] = useState<string | null>(null)
    const searchParams = useSearchParams()
    const cocktailId = searchParams?.get('cocktailId')
    useEffect(() => {
        setSelected(null)
    }, [cocktailId])
    const { cocktailInfo, changeMlToOz } = props;
    const { storeConfig: {
        cocktailList,
        newTabForProductDetail
    } } = useCmsStore()!
    const linkProps = newTabForProductDetail ? { target: '_blank' } : { target: '' }
    const type = changeMlToOz ? 'oz' : 'ml'
    const productCallBackUrl = cocktailList.find((item) => item.cocktailID.name === cocktailInfo.id)?.productCallbackURL || '';
    function calculateUnit(ml: string, oz: string) {
        if (!ml && !oz) {
            return '';
        }
        if (type === 'ml') {
            if (ml) {
                return parseInt(selected || '1') * Number(ml) + ' ml';
            }
            return parseInt(selected || '1') * Number(oz || '0') + ' oz';
        }
        if (type === 'oz') {
            if (oz) {
                return parseInt(selected || '1') * Number(oz) + ' oz';
            }
            return parseInt(selected || '1') * Number(ml || '0') + ' ml';
        }
    }
    function validateUrl() {
        const url = cocktailInfo.productUrlEcommerce
        if (!url) {
            return false
        }
        return url.startsWith('http') || url.startsWith('https') || url.startsWith('/')
    }
    const showEcommerceWrapper = validateUrl() || cocktailInfo.productDescriptionEcommerce || cocktailInfo.productImageEcommerce?.url || cocktailInfo.productTitleEcommerce
    return <div className="cocktail-ingredients-wrapper">
        <div className="top-basic-wrapper">
            <h2 className="crafting-title sub-title">{props.titleEssential}</h2>

            <div className="select-wrapper">
                <Selector
                    className="people-select"
                    options={Array.from({ length: 5 }, (_, i) => ({
                        label: `${i + 1}  ${i === 0 ? props.stringPerson : props.stringPeople}`,
                        value: `${i + 1}`
                    }))}
                    selected={selected}
                    defaultValue={props.stringNumberOfServes}
                    onSelect={(value) => {
                        setSelected(value)
                        props.onChangeSelectedPersons(Number(value))
                    }}
                />
                {
                    cocktailInfo.alcoholVol && <div className="selected-result-wrapper">
                        <span className="selected-text"> {cocktailInfo.alcoholVol} {props.stringUnitsOfAlcoholPerServe} </span>
                        <IconVol />
                    </div>
                }

            </div>

        </div>
        <div className="bottom-wrapper">
            {
                showEcommerceWrapper && <div className="ecommerce-wrapper">
                    <div className="ecommerce-top-wrapper">
                        <div className="ecommerce-content">
                            <div className="ecommerce-title">{cocktailInfo.productTitleEcommerce}</div>
                            <div className="ecommerce-desc">{cocktailInfo.productDescriptionEcommerce}</div>
                        </div>
                        {
                            cocktailInfo.productImageEcommerce?.url && <div className="ecommerce-media-wrapper">
                                <img src={cocktailInfo.productImageEcommerce.url} alt={cocktailInfo.productTitleEcommerce} />
                            </div>
                        }

                    </div>
                    {
                        productCallBackUrl && <DdpCta className="ecommerce-cta" cta={{
                            text: props.cTANameEcommerce,
                            show: true,
                            url: productCallBackUrl
                        }}
                            {...linkProps}
                        >
                        </DdpCta>
                    }

                </div>
            }

            <div className="ingredients-wrapper">
                <div className="left-wrapper">
                    <div className="ingredients-title sub-title">{props.titleIngredient}</div>
                    <div className="list-wrapper">
                        <div className="ingredients-list">
                            {
                                cocktailInfo?.ingredients?.map((item) => {
                                    if (!(Number(item.quantity_ml) > 0 || Number(item.quantity_oz) > 0 || Number(item.quantity) > 0)) return null;
                                    return <div className="ingredient-item" key={item.ingredient}>
                                        <IconSelectedOutline />
                                        <span className="ingredient-amount">
                                            {item.quantity && <strong>{parseInt(selected || '1') * Number(item.quantity)}</strong>}
                                            {
                                                (item.quantity_ml || item.quantity_oz) && <strong>{calculateUnit(item.quantity_ml, item.quantity_oz)}</strong>
                                            }
                                            {' ' + item.ingredient}
                                        </span>
                                    </div>
                                })
                            }
                        </div>
                    </div>
                </div>
                <div className="right-wrapper">
                    <div className="ingredients-title sub-title">{props.titleEquipment}</div>
                    <div className="list-wrapper">
                        <div className="equipment-list">
                            {
                                cocktailInfo?.equipment?.map((item) => {
                                    return <div className="ingredient-item" key={item.equipment}>
                                        <IconSelectedOutline />
                                        <span className="ingredient-amount">{item.equipment}</span>
                                    </div>
                                })
                            }
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

}